import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class UsuariosService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getUsuarios(){
    return this.http.get(`${this.API_URI}/usuarios`)
  }

  getUsuario(id:string){
    return this.http.get(`${this.API_URI}/usuarios/${id}`);
  }

  actualizarUsuario(id: string | number, datos: any): Observable<any> {
    return this.http.put(`${this.API_URI}/usuarios/${id}`, datos);
  }
  
  crearUsuario(datos: any) {
    return this.http.post(`${this.API_URI}/usuarios`, datos);
  }

  eliminarUsuario(id: string): Observable<any> {
    return this.http.delete(`${this.API_URI}/usuarios/${id}`);
  }

}